import PropTypes from 'prop-types';

function memberContainer({ children, isContainerOpen }) {
  return (
    <div className="member">
      <div
        className={`memberContainer ${
          isContainerOpen ? 'memberOpened' : 'memberClosed'
        }`}
        style={{ backgroundColor: '#FFF' }}
      >
        {children}
      </div>
    </div>
  );
}

memberContainer.propTypes = {
  isContainerOpen: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default memberContainer;
